<template>
  <div style="width: 350px; margin: auto">
    <el-form
      size="small"
      align="center"
      label-position="left"
      status-icon
      label-width="0px"
    >
      <el-form-item prop="crafite_name">
        <el-input
          type="textarea"
          :autosize="{ minRows: 3, maxRows: 7 }"
          placeholder="Please enter the processing description"
          v-model="deal_des"
        >
        </el-input>
      </el-form-item>

      <el-form-item align="right">
        <el-button class="el-button--small" @click="$emit('closeAdd')"
          >Back</el-button
        >
        <el-button
          class="el-button--small el-button--primary"
          @click="submit('formData')"
          >Save</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "WarnUpate",
  props: {
    chooseItem: Object,
    closeAdd: Function,
  },
  data() {
    return {
      deal_des: "",
    };
  },
  methods: {
    submit() {
      let params={
          warn_id:this.chooseItem.warn_id,
          deal_type:0,
          deal_des:this.deal_des
      }
      this.$api.rootV1.post(
        "/web/warning/deal",
        params,
        (res) => {
            this.$emit("closeAdd");
            this.$message.success('Successfully processed!')
        },
        (res) => {
            this.$emit("closeAdd");
            this.$message.success('Processing failed!')
        }
      );
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/main/warning/WarnUpdate.vue